import {
  PLAYER_EVENTS,
  Player,
} from "@flussonic/flussonic-webrtc-player";

let wrtcPlayer = null;

const getPlayerElement = () => document.getElementById("player");

const STOP = 'STOP';
const THIRTY_SECONDS = 30000;
const AUDIO_TRACKS = [
    {
        title: 'Equities',
        streamURL: 'equities-realtime',
    },
    {
        title: 'Audio Test',
        streamURL: 'audio_test',
    },
    {
        title: 'Stop',
        streamURL: STOP,
    }
]

const getPlayer = (streamUrl) => {
  const playerOpts = {
      retryMax: 10,
      retryDelay: 1000,
      statsSendEnable: false,
      whipwhap: false,
  };
  const playerElement = getPlayerElement();
  const log = (...defaultMessages) => (...passedMessages) => console.log(...[...defaultMessages, ...passedMessages]);
  const player = new Player(playerElement, streamUrl, playerOpts, true);
  player.on(PLAYER_EVENTS.PLAY, log("Started playing", streamUrl));
  player.on(PLAYER_EVENTS.DEBUG, log("Debugging play"));
  return player;
};

const play = (streamURL) => {
  if (wrtcPlayer) {
    wrtcPlayer.destroy && wrtcPlayer.destroy();
    wrtcPlayer = null;
  }

  if (streamURL === STOP) {
      return;
  }

  wrtcPlayer = getPlayer(`https://webrtc2.newsquawk.com/live/${streamURL}`);
  window.webrtcPlayer = wrtcPlayer;
  wrtcPlayer.play();
};

const convertUnixTimestampToMilitaryTime = (unixTimestamp) => {
    // Multiply by 1000 if the Unix timestamp is in seconds (not milliseconds)
    const date = new Date(unixTimestamp * 1000);

    // Get hours and minutes in local time
    let hours = date.getHours();
    let minutes = date.getMinutes();

    // Pad with leading zeros if necessary
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutes}`;
}

const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
}

const groupArticlesByDate = (articles) => {
    const grouped = {};

    articles.forEach(article => {
        // Format the timestamp into a readable date
        const formattedDate = formatDate(article.time);

        // Check if the date already exists in the grouped object, if not, create it
        if (!grouped[formattedDate]) {
            grouped[formattedDate] = [];
        }

        // Add the article to the corresponding date
        grouped[formattedDate].push(article);
    });

    return grouped;
}

const sortGroupedArticlesByDate = (groupedArticles) => {
    // Get the keys (dates) and sort them in descending order
    const sortedDates = Object.keys(groupedArticles).sort((a, b) => {
        const dateA = new Date(a);
        const dateB = new Date(b);
        return dateB - dateA; // Sort in descending order
    });

    // Create a new object with sorted dates
    const sortedGrouped = {};
    sortedDates.forEach(date => {
        sortedGrouped[date] = groupedArticles[date];
    });

    return sortedGrouped;
}


const fetchNews = async () => {
    const response = await fetch('https://breaking-news.jbtb.workers.dev/');
    const json = await response.json();
    const datesForNews = sortGroupedArticlesByDate(groupArticlesByDate(json));

    const innerHTMLContent = Object.entries(datesForNews).map(([date, newsStories]) => {
        const newsStoriesHTML = newsStories.map(({ time, title, source }) => `
            <div class="newsStory">
                <div class="timestamp">${convertUnixTimestampToMilitaryTime(time)}</div>
                <div class="newsTitle">${title} <div class="source">${source}</div></div>
            </div>
        `);

        return `<div class="newsStoriesForDate"><div class="date">${date}</div> ${newsStoriesHTML.join('')}</div>`
    });

    document.getElementById('newsStories').innerHTML = innerHTMLContent.join('');
};

const initializeNewsPolling = () => {
    void fetchNews();
    setInterval(fetchNews, THIRTY_SECONDS);
};

const updateTimeDisplay = () => {
    function updateTime() {
        const now = new Date();
        const options = {
            timeZone: "America/New_York",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        };
        document.getElementById("time").innerText = new Intl.DateTimeFormat("en-US", options).format(now);
    }

    setInterval(updateTime, 1000); // Update every second
}

const initializeControls = () => {
    const container = document.getElementById('header-controls');

    AUDIO_TRACKS.forEach((({ title, streamURL }) => {
        const trackElement = document.createElement('div');
        trackElement.classList.add('audio-track');
        trackElement.textContent = title;
        trackElement.addEventListener("click", () => {
            const allAudioTrackElements = document.querySelectorAll('.audio-track');
            allAudioTrackElements.forEach((button) => button.classList.remove('audio-track-selected'));
            trackElement.classList.add('audio-track-selected');
            play(streamURL);
        });

        // default to "STOP" being selected on initial load
        if (streamURL === STOP) {
            trackElement.classList.add('audio-track-selected');
        }

        container.appendChild(trackElement);
    }));
}

// auto initialize stream on load
window.addEventListener("load", initializeControls);
window.addEventListener("load", initializeNewsPolling);
window.addEventListener("load", updateTimeDisplay);

// there needs to be a click event fired in order for streaming to begin
// appContainer.addEventListener("click", play);
